// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"622ff532","103":"5489387f","664":"e312acf2","695":"b73ae294","808":"cd4fc58b"}[chunkId] + ".chunk.js";
};